/*
  Quick "Add to cart" buttons on the homepage product cards.

  Adds 1 unit of the card's variant with POST /cart/add.js (no page reload), then announces it the
  same way the theme's own product-page form does ("ajaxProduct:added"). The cart drawer listens
  for that event (rebuilds itself, updates the header count and opens), and so does the automatic
  free-item mechanic (assets/free-gift.js), so a quick add triggers the free-item check exactly
  like an add from a product page.
*/
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = root + 'cart/add.js';

  var LABEL_ADDING = 'Adding...';
  var LABEL_ADDED = 'Added ✓';
  var MESSAGE = 'Sorry, could not add this item';
  var MESSAGE_MS = 4000;
  var ADDED_MS = 2000;

  function showMessage(button, text) {
    var box = button.parentElement && button.parentElement.querySelector('.quick-add__message');
    if (!box) { return; }
    box.textContent = text;
    box.hidden = false;
    window.clearTimeout(box.__timer);
    box.__timer = window.setTimeout(function () {
      box.hidden = true;
      box.textContent = '';
    }, MESSAGE_MS);
  }

  function hideMessage(button) {
    var box = button.parentElement && button.parentElement.querySelector('.quick-add__message');
    if (box) { box.hidden = true; box.textContent = ''; }
  }

  function drawerIsOpen() {
    var html = document.documentElement;
    return html.classList.contains('js-drawer-open') || html.classList.contains('js-drawer-open-cart');
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target && evt.target.closest ? evt.target.closest('[data-quick-add]') : null;
    if (!button) { return; }

    // the button never behaves as a link, and never lets a click reach the card's link
    evt.preventDefault();
    evt.stopPropagation();

    // one add at a time per button: this is what stops a rapid double-click adding twice
    if (button.__adding || button.disabled) { return; }

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) { return; }

    var original = button.textContent;
    var hadFocus = document.activeElement === button;

    button.__adding = true;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('quick-add__button--adding');
    button.textContent = LABEL_ADDING;
    hideMessage(button);

    function reset(text) {
      button.textContent = text;
      button.__adding = false;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('quick-add__button--adding');
      if (hadFocus) { button.focus(); }
    }

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || (json && json.status && json.status >= 400)) {
            throw new Error('add failed');
          }
          return json;
        });
      })
      .then(function (item) {
        // same announcement the theme makes after an add from a product page: the cart drawer rebuilds
        // itself, updates the header count and opens, and the free-item check runs
        button.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: item, addToCartBtn: button },
          bubbles: true
        }));

        reset(original);

        // if the drawer did not open, fall back to a brief "Added ✓" on the button
        window.setTimeout(function () {
          if (drawerIsOpen() || button.__adding) { return; }
          button.textContent = LABEL_ADDED;
          window.setTimeout(function () {
            if (!button.__adding) { button.textContent = original; }
          }, ADDED_MS);
        }, 700);
      })
      .catch(function () {
        reset(original);
        showMessage(button, MESSAGE);
      });
  });
})();
